/* eslint-disable @typescript-eslint/member-ordering */
import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { faClose } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'empathy-comments-filter',
  templateUrl: 'comments-filter.component.html',
  styleUrls: ['./comments-filter.component.scss', './_comments-filter-theme.component.scss']
})
export class CommentsFilterComponent {
  @Input() allowFilterRemoval: boolean;
  @Input() set filterValue(filterValue: string) {
    this.commentsFilterValue$.set(filterValue);
    if(filterValue) {
      this.filterControl.setValue(true);
    }
  }

  @Output() filter = new EventEmitter<string>();
  @Output() removeFilter = new EventEmitter<void>();

  commentsFilterValue$ = signal('');

  faClose = faClose;

  filterControl = new FormControl(false);

  onApplyFilter(): void {
   this.filter.emit(this.commentsFilterValue$());
   this.filterControl.setValue(true);
  }

  onShowAll(): void {
    this.filter.emit('');
    this.filterControl.setValue(false);
   }
}
